import { HIDE_ACCOUNT_MODAL } from 'actions';

export function hideAccountModal() {
  return { type: HIDE_ACCOUNT_MODAL };
}
